import { FaShoppingCart, FaChalkboardTeacher } from "react-icons/fa";
import { RiShieldUserFill } from "react-icons/ri";
import { IoBarChart } from "react-icons/io5";
import {
  FaUserShield,
  FaBuildingShield,
  FaHandHoldingDollar,
  FaEarthAmericas,
  FaPeopleGroup,
  FaFileInvoiceDollar,
  FaRegChartBar,
} from "react-icons/fa6";
import { MdOutlineWifiProtectedSetup, MdCurrencyExchange } from "react-icons/md";
import { GiPriceTag } from "react-icons/gi";
import { BsStars } from "react-icons/bs";

export const menu = [
  {
    id: 1,
    name: "Home",
    url: "/",
  },
  {
    id: 3,
    name: "Industries",
    url: "/industries/life-insurance",
    submenu: [
      {
        id: 1,
        name: "Life Insurance",
        url: "/industries/life-insurance",
        icon: <RiShieldUserFill className="text-xl" />,
      },
      {
        id: 2,
        name: "Property & Casualty Insurance",
        url: "/industries/property-and-casualty-insurance",
        icon: <FaBuildingShield className="text-lg" />,
      },
      {
        id: 3,
        name: "Employee Benefits",
        url: "/industries/employee-benefits",
        icon: <FaUserShield className="text-xl" />,
      },
      {
        id: 4,
        name: "Reinsurance",
        url: "/industries/reinsurance",
        icon: <MdOutlineWifiProtectedSetup className="text-xl" />,
      },
      {
        id: 5,
        name: "Wealth Management & Banking",
        url: "/industries/wealth-management-and-banking",
        icon: <FaHandHoldingDollar className="text-xl" />,
      },
      {
        id: 6,
        name: "E-Commerce & Consumer Goods",
        url: "/industries/e-commerce-and-consumer-goods",
        icon: <FaShoppingCart className="text-lg" />,
      },
    ],
  },
  {
    id: 2,
    name: "Solutions",
    url: "/solutions/sales-prophet",
    submenu: [
      { id: 1, name: "Sales Prophet™", url: "/solutions/sales-prophet", icon: <FaEarthAmericas /> },
      { id: 2, name: "Lead Prioritizer™", url: "/solutions/lead-prioritizer", icon: <FaChalkboardTeacher /> },
      { id: 3, name: "UW Engine", url: "/solutions/uw-engine", icon: <RiShieldUserFill /> },
      { id: 4, name: "Renewals Optimizer", url: "/solutions/renewals-optimizer", icon: <MdCurrencyExchange /> },
      { id: 5, name: "Commission Intelligence", url: "/solutions/commission-intelligence", icon: <FaFileInvoiceDollar /> },
      { id: 6, name: "Cartalyze™", url: "/solutions/cartalyze", icon: <GiPriceTag /> },
      { id: 7, name: "4Qast™", url: "/solutions/4qast", icon: <IoBarChart /> },
      { id: 8, name: "CapMod™", url: "/solutions/capmod", icon: <FaPeopleGroup /> },
      { id: 9, name: "Returnify", url: "/solutions/returnify", icon: <MdCurrencyExchange /> },
      { id: 10, name: "Scenario Planner", url: "/solutions/scenario-planner", icon: <IoBarChart /> },
      { id: 11, name: "Lapse Predictor", url: "/solutions/lapse-predictor", icon: <FaRegChartBar /> },
      { id: 12, name: "DECISIS", url: "/solutions/decisis", icon: <BsStars /> },
      { id: 13, name: "Data Enrichment", url: "/solutions/data-enrichment", icon: <FaEarthAmericas /> },
    ],
  },
  {
    id: 4,
    name: "About Us",
    url: "/about-us",
    submenu: [
      {
        id: 1,
        name: "Our Approach",
        url: "/about-us/#our-approach",
        // icon: <HiChevronDoubleRight/>
      },
      {
        id: 2,
        name: "Our Clients",
        url: "/about-us/#our-clients",
        // icon: <HiChevronDoubleRight/>
      },
      {
        id: 3,
        name: "Our Team",
        url: "/about-us/#our-team",
        // icon: <HiChevronDoubleRight/>,
      },
      {
        id: 4,
        name: "Our Reach",
        url: "/about-us/#our-reach",
        // icon: <HiChevronDoubleRight/>,
      },
    ],
  },
  {
    id: 5,
    name: "Insights",
    url: "/insights",
  },
  {
    id: 6,
    name: "Contact",
    url: "/contact",
  },
];

export const footerMenu = [
  {
    id: 1,
    name: "Pages",
    submenu: [
      {
        id: 1,
        name: "Home",
        url: "/",
      },
      {
        id: 2,
        name: "Industries",
        url: "/industries/life-insurance",
      },
      {
        id: 3,
        name: "Solutions",
        url: "/solutions/sales-prophet",
      },
      {
        id: 4,
        name: "About Us",
        url: "/about-us",
      },
      {
        id: 5,
        name: "Insights",
        url: "/insights",
      },
      {
        id: 6,
        name: "Contact",
        url: "/contact",
      },
    ],
  },
  {
    id: 2,
    name: "Industries",
    submenu: [
      {
        id: 1,
        name: "Life Insurance",
        url: "/industries/life-insurance",
      },
      {
        id: 2,
        name: "Property & Casualty Insurance",
        url: "/industries/property-and-casualty-insurance",
      },
      {
        id: 3,
        name: "Employee Benefits",
        url: "/industries/employee-benefits",
      },
      {
        id: 4,
        name: "Reinsurance",
        url: "/industries/reinsurance",
      },
      {
        id: 5,
        name: "Wealth Management & Banking",
        url: "/industries/wealth-management-and-banking",
      },
      {
        id: 6,
        name: "E-Commerce & Consumer Goods",
        url: "/industries/e-commerce-and-consumer-goods",
      },
    ],
  },
  {
    id: 3,
    name: "Solutions",
    submenu: [
      { id: 1, name: "Sales Prophet™", url: "/solutions/sales-prophet" },
      { id: 2, name: "Lead Prioritizer™", url: "/solutions/lead-prioritizer" },
      { id: 3, name: "UW Engine", url: "/solutions/uw-engine" },
      { id: 4, name: "Renewals Optimizer", url: "/solutions/renewals-optimizer" },
      { id: 5, name: "Commission Intelligence", url: "/solutions/commission-intelligence" },
      { id: 6, name: "Cartalyze™", url: "/solutions/cartalyze" },
      { id: 7, name: "4Qast™", url: "/solutions/4qast" },
      { id: 8, name: "CapMod™", url: "/solutions/capmod" },
      { id: 9, name: "Returnify", url: "/solutions/returnify" },
      { id: 10, name: "Scenario Planner", url: "/solutions/scenario-planner" },
      { id: 11, name: "Lapse Predictor", url: "/solutions/lapse-predictor" },
      { id: 12, name: "DECISIS", url: "/solutions/decisis" },
      { id: 13, name: "Data Enrichment", url: "/solutions/data-enrichment" },
      { id: 14, name: "Custom Solutions", url: "/solutions/custom-solutions" },
    ],
  },
  {
    id: 4,
    name: "About Us",
    submenu: [
      {
        id: 1,
        name: "Our Approach",
        url: "/about-us/#our-approach",
      },
      {
        id: 2,
        name: "Our Clients",
        url: "/about-us/#our-clients",
      },
      {
        id: 3,
        name: "Our Team",
        url: "/about-us/#our-team",
      },
      {
        id: 4,
        name: "Our Reach",
        url: "/about-us/#our-reach",
      },
    ],
  },
  {
    id: 5,
    name: "Legal",
    submenu: [
      {
        id: 1,
        name: "Terms & Conditions",
        url: "/terms-and-conditions",
      },
      {
        id: 2,
        name: "Privacy-policy",
        url: "privacy-policy",
      },
    ],
  },
];
